var translateurl = document.location.href;
function google_trans() {
    if (iCreateObject.isSiteinICreateMode)        showNAMessage();    else        document.location.href = iCreateObject.corpHome + "/" + iCreateObject.lang + "/includes/googleTranslate/googletranslate.aspx?url=" + escape(translateurl);
}